import React from 'react';
import { motion } from 'framer-motion';

const LevelBadge = ({ level, size = 'md' }) => {
  const sizeClasses = {
    sm: 'w-12 h-12 text-lg',
    md: 'w-16 h-16 text-2xl',
    lg: 'w-24 h-24 text-4xl'
  };

  return (
    <motion.div
      whileHover={{ scale: 1.1, rotate: 5 }}
      className={`${sizeClasses[size]} bg-gradient-to-br from-ssdp-purple to-ssdp-teal border-4 border-ssdp-navy rounded-full flex items-center justify-center font-black shadow-[4px_4px_0px_0px_rgba(30,58,89,1)] text-white font-heading`}
      data-testid="level-badge"
    >
      {level}
    </motion.div>
  );
};

export default LevelBadge;